import length, { LengthSystems, LengthUnits } from "convert-units/definitions/length";
import speed, { SpeedSystems, SpeedUnits } from "convert-units/definitions/speed";
import volumeFlowRate, { VolumeFlowRateSystems, VolumeFlowRateUnits } from "convert-units/definitions/volumeFlowRate";

import configureMeasurements from 'convert-units';

export type Measures = "length" | "volumeFlowRate" | "speed";
export type Systems = LengthSystems | VolumeFlowRateSystems | SpeedSystems;
export type Units = LengthUnits | VolumeFlowRateUnits | SpeedUnits;

const convert = configureMeasurements<Measures, Systems, Units>({
  length,
  volumeFlowRate,
  speed,
});

export default convert;

export const isUnit = (str: string): str is Units =>
  !!convert()
    .possibilities()
    .find((s) => str === s);

export const isLengthUnit = (str: string): str is LengthUnits =>
  !!convert()
    .possibilities("length")
    .find((s) => str === s);

export const isVolumeFlowRateUnit = (str: string): str is VolumeFlowRateUnits =>
  !!convert()
    .possibilities("volumeFlowRate")
    .find((s) => str === s);


export const normalizeLengthUnit = (unit: string| undefined): LengthUnits => {
  const unit_ = unit && unit.trim().toLowerCase();
  switch (unit_) {
    case "feet":
      return "ft";
    case "inches":
      return "in";
    default:
      if (unit_ && isLengthUnit(unit_)) {
        return unit_;
      }
      throw new Error(`Unhandled unit ${unit}`);
  }
};

export const normalizeFlowRateUnit = (unit: string| undefined): VolumeFlowRateUnits => {
  const unit_ = unit && unit.trim().toLowerCase();
  switch (unit_) {
    case "cfs":
      return "ft3/s";
    case "gpm":
      return "gal/min";
    default:
      if (unit_ && isVolumeFlowRateUnit(unit_)) {
        return unit_;
      }
      throw new Error(`Unhandled unit ${unit}`);
  }
};